// extracted by mini-css-extract-plugin
export var editInput = "_kf-0";
export var editInputCompact = "_kf-2";
export var editInputLarge = "_kf-1";
export var editInputSmall = "_kf-3";